/**
 * Lightweight public-status hook. Fetches /api/system/status once
 * (it's unauthenticated + cheap) and exposes the feature flags so
 * the UI can hide surfaces that the backend can't actually fulfill
 * (e.g. voice channels when LiveKit creds aren't configured).
 */
import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;

export function useSystemStatus() {
  const [status, setStatus] = useState(cache);

  useEffect(() => {
    if (cache) return;
    let cancelled = false;
    axios
      .get(`${API}/system/status`)
      .then((res) => {
        cache = res.data;
        if (!cancelled) setStatus(res.data);
      })
      .catch(() => {
        // Fall back to defaults — assume voice OFF so we don't
        // present a broken feature on misconfigured deploys.
        if (!cancelled) setStatus({ voice_enabled: false });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return status;
}
